/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import {
  CostCenterFinderDialogConfig,
  costCenterFinderDialogRoute,
  CostCenterFinderListItem,
} from '@gh/builder-shared';
import { PRIVILEGED_EP_SYS_VARS_ESTIMATING_ORDERS } from '@gh/builder-shared-data';
import { ContextRoute, getContextRouteInitData } from '@gh/common-internal-shared';
import { getSingleNewSelectedEntity, updatePrivilegedControls } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { DialogService, getControlValue } from '@gh/core-ui';
import { filter$, map$ } from '@gh/rx/operators';
import { assign } from 'lodash';
import { SystemVarsEstimatingOrderSubTabFormState } from './system-vars-estimating-orders-subtab.form.service';

@Component({
  selector: 'gh-system-vars-estimating-common-subtab',
  template: require('./system-vars-estimating-orders-subtab.component.html'),
  styles: [require('./system-vars-estimating-orders-subtab.component.scss')],
})
export class SystemVarsEstimatingOrdersSubTabComponent implements OnInit {
  costCenter?: CostCenterFinderListItem;

  constructor(private route: ContextRoute,
              public form: SystemVarsEstimatingOrderSubTabFormState,
              private dialogService: DialogService) {
  }

  ngOnInit(): void {
    assign(this, getContextRouteInitData(this.route));
  }

  getPreselected(): ID[] {
    const costCenter = getControlValue(this.form.group, 'costCenter');
    return costCenter ? [costCenter.id] : [];
  }

  findCostCenter(): void {
    this.dialogService.openWithInput(costCenterFinderDialogRoute, <CostCenterFinderDialogConfig>{
      multiselection: false,
      preselected: this.getPreselected(),
    }).afterClosed().pipe(
      filter$(Boolean),
      map$(getSingleNewSelectedEntity))
      .subscribe((costCenter: CostCenterFinderListItem) => {
        this.form.get('costCenter').setValue(costCenter);
        this.form.get('costCenter').markAsDirty();
      });
  }

  onPrivilegedTokenReceivedOrders(): void {
    updatePrivilegedControls(this.form, PRIVILEGED_EP_SYS_VARS_ESTIMATING_ORDERS);
  }
}
